// src/plugins/i18n.ts
import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import no from '../locales/no.json'
import { DEFAULT_LOCALE } from '@/router/locales' // eller der den faktisk ligger

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, no }
})
